"use client";

import AchievementCard from "@/components/ui/AchievementCard";
import CertificateCard from "@/components/ui/CertificateCard";
import CertificateModal from "@/components/ui/CertificateModal";
import { useAppContext } from "@/providers/AppProvider";
import { IAchievement, ICertificate } from "@/types";
import { motion } from "framer-motion";
import dynamic from "next/dynamic";
import { useState } from "react";
const AchievementModal = dynamic(
    () => import("@/components/ui/AchievementModal"),
    { ssr: false },
);

const containerVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const fadeUpVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
};

function Achievements() {
    const { certificates, achievements } = useAppContext();
    const [selectedAchievement, setSelectedAchievement] =
        useState<IAchievement | null>(null);
    const [selectedCertificate, setSelectedCertificate] =
        useState<ICertificate | null>(null);

    return (
        <div className="space-y-8">
            {achievements.length > 0 && (
                <motion.section
                    className="p-2"
                    initial="hidden"
                    animate="visible"
                    viewport={{
                        once: false,
                        amount: 0.3,
                    }}
                    variants={containerVariants}
                >
                    <motion.h2
                        variants={fadeUpVariants}
                        className="mb-4 text-3xl font-bold text-primary lg:text-4xl"
                    >
                        Achievements
                    </motion.h2>
                    <motion.div
                        className="grid-cols-autofit grid h-full gap-4"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{
                            once: false,
                            amount: 0.2,
                        }}
                    >
                        {achievements.map((achievement, index) => (
                            <motion.div key={index} variants={fadeUpVariants}>
                                <AchievementCard
                                    achievement={achievement}
                                    onClick={setSelectedAchievement}
                                />
                            </motion.div>
                        ))}
                    </motion.div>
                </motion.section>
            )}

            <motion.section
                className="p-2"
                initial="hidden"
                animate="visible"
                viewport={{
                    once: false,
                    amount: 0.3,
                }}
                variants={containerVariants}
            >
                <motion.h2
                    variants={fadeUpVariants}
                    className="mb-4 text-3xl font-bold text-primary lg:text-4xl"
                >
                    Certificates
                </motion.h2>
                <motion.div
                    className="grid-cols-autofit grid gap-4"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{
                        once: false,
                        amount: 0.2,
                    }}
                >
                    {[...certificates]
                        .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
                        .map((certificate, index) => (
                            <motion.div key={index} variants={fadeUpVariants}>
                                <CertificateCard
                                    certificate={certificate}
                                    onClick={setSelectedCertificate}
                                />
                            </motion.div>
                        ))}
                </motion.div>

                <AchievementModal
                    achievement={selectedAchievement}
                    onClose={() => setSelectedAchievement(null)}
                />

                <CertificateModal
                    certificate={selectedCertificate}
                    onClose={() => setSelectedCertificate(null)}
                />
            </motion.section>
        </div>
    );
}

export default Achievements;
